import { Paper, Typography, Button } from '@material-ui/core'

import AddIcon from '@material-ui/icons/Add'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { BackButton, ButtonGrid, Page } from '../../components'
import { locale } from '../../locale'
import { initializeAdmin } from '../../state/Firebase/operations'
import { createUserStart } from '../../state/SystemCache/actions'
import { useMoveMenuPage } from '../App/operations'
import NavBar from '../NavBarContainer'
import CreateUserFormModalContainer from '../UserForm/CreateUserFormModal'
import UserFormModalContainer from '../UserForm/UserFormModal'
import { useAuth } from '../Auth/useAuth'
import ClientListContainer from './ClientListContainer'

type Props = {}

function AdminClientPage(_props: Props) {
  const dispatch = useDispatch()
  const moveMenu = useMoveMenuPage()

  React.useEffect(() => {
    dispatch(initializeAdmin())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div>
      <Helmet>
        <title>クライアント管理</title>
      </Helmet>
      <NavBar />
      <Page>
        <Typography variant="h5">{locale.clientEntity}管理</Typography>
        <Paper>
          <ButtonGrid>
            <Button onClick={() => dispatch(createUserStart())}>
              <AddIcon />
              {locale.clientEntity}の追加
            </Button>
            <BackButton onClick={moveMenu}>戻る</BackButton>
          </ButtonGrid>
          <ClientListContainer />
        </Paper>
      </Page>
      <CreateUserFormModalContainer />
      <UserFormModalContainer />
    </div>
  )
}
const AdminClientPageLogin = () => {
  const res = useAuth()

  if (res.loading && res.Loader) return <res.Loader />
  if (!res.login) return null
  return <AdminClientPage />
}

export default AdminClientPageLogin
